import PropTypes from "prop-types"
import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { buildSignature, createBuildRefresh, fetchLatestSignature } from "helpers/buildRefresh"

// Loads a newly deployed CP build: right after the page loads, or at the next page change once a check on returning to
// the tab or on a page change finds it. Only production builds carry content-hashed entry scripts to compare.
export default function BuildRefresh({ enabled = process.env.NODE_ENV === "production", latest = fetchLatestSignature,
  reload = () => window.location.reload() }) {
  const { pathname } = useLocation()
  const refresh = useRef(null)
  if (!refresh.current && enabled) refresh.current = createBuildRefresh({ running: buildSignature(document), latest, reload })

  useEffect(() => {
    if (!refresh.current) return undefined
    const returned = () => { if (document.visibilityState === "visible") refresh.current.check() }
    document.addEventListener("visibilitychange", returned)
    window.addEventListener("focus", returned)
    return () => {
      document.removeEventListener("visibilitychange", returned)
      window.removeEventListener("focus", returned)
    }
  }, [])

  // The first run is the check right after loading. Query and hash changes (list filters, tabs kept in the URL) stay on
  // the same page and never reload it.
  useEffect(() => {
    refresh.current?.pageChanged()
  }, [pathname])

  return null
}

BuildRefresh.propTypes = {
  enabled: PropTypes.bool,
  latest: PropTypes.func,
  reload: PropTypes.func,
}
